<template>
    <div class="home">
        <grid-two-column>
            <template slot="aside-left">
                <sidebar-left></sidebar-left>
            </template>
            <template slot="main">
                <home-content></home-content>
            </template>
        </grid-two-column>
    </div>
</template>
<script>
import homeContent from "@/components/home/home-content.vue"
export default {
    name: 'Home',
    metaInfo() {
        return {
            title: "Arclif - Free houseplan and architecture services"
        }
    },
    components: {
        'home-content': homeContent
    }
}
</script>